import MenuIcon from '@material-ui/icons/Menu';
import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const { WHITE, BLACK } = COLORS;

const menuItemsRightMargin = 15;

const Nav = styled.nav`
  background: #000;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  z-index: 100;
  position: relative;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  img.logo {
    width: 182px;
  }
`;

const Logo = styled.img`
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  transition: all ease-out 0.5s;
  @media (max-width: 650px) {
    width: 117px;
    padding-left: 10px;
    padding-right: 5px;
  }
`;

const Bars = styled(MenuIcon)`
  font-size: 20px;
  cursor: pointer;
  color: ${WHITE};
  background-color: ${BLACK};
  border-color: ${BLACK};
  padding: 8px 12px;
  border-radius: 3px;
  box-sizing: content-box;
  margin-top: 10px;
  @media (max-width: 650px) {
    padding: 5px 6px;
  }
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 651px) {
    display: none;
  }
`;

const Btn = styled.div`
  display: flex;
  align-items: center;
`;

const CurrencyFlag = styled.img`
  width: 29px;
  margin-right: ${menuItemsRightMargin}px;
  cursor: pointer;
  margin-left: 5px;
`;

const UserName = styled.div`
  color: #fff;
  margin-right: ${menuItemsRightMargin}px;
  @media (max-width: 651px) {
    margin-right: 0;
    text-align: right;
  }
`;
const CurrencyMenu = styled.div`
  display: flex;
  align-items: center;
  color: #fff;
`;
const MobileMenu = styled.div`
  display: none;
  @media (max-width: 650px) {
    display: flex;
    align-items: center;
  }
`;
export {
  Nav,
  Wrapper,
  Logo,
  Bars,
  Menu,
  Btn,
  CurrencyFlag,
  menuItemsRightMargin,
  UserName,
  CurrencyMenu,
  MobileMenu,
};
